// Simple session-based auth service
// Backend handles all OIDC communication, frontend just uses cookies

import { getRuntimeConfig } from './runtimeConfig'

function getApiBase(): string {
  const cfg = getRuntimeConfig()
  const base = (cfg?.apiUrl || import.meta.env.VITE_API_URL || 'https://freeholdapi.ntg.co').replace(/\/+$/, '')
  // Ensure we have /api/v1 suffix
  if (base.endsWith('/api/v1')) {
    return base
  }
  return `${base}/api/v1`
}

export interface SessionUser {
  id: string
  email: string
  display_name: string
  is_admin: boolean
}

export interface SessionResponse {
  authenticated: boolean
  user?: SessionUser
  expires_at?: string
}

export async function checkSession(): Promise<SessionResponse> {
  try {
    const response = await fetch(`${getApiBase()}/auth/session`, {
      credentials: 'include', // Important: send cookies
    })
    if (!response.ok) {
      return { authenticated: false }
    }
    return await response.json()
  } catch (error) {
    console.error('[Auth] Failed to check session:', error)
    return { authenticated: false }
  }
}

export function redirectToLogin(): void {
  // Redirect to backend login endpoint which handles OIDC
  window.location.href = `${getApiBase()}/auth/login`
}

export async function logout(): Promise<void> {
  try {
    await fetch(`${getApiBase()}/auth/logout`, {
      method: 'POST',
      credentials: 'include',
    })
  } catch (error) {
    console.error('[Auth] Logout failed:', error)
  }
  // Redirect to login page regardless
  window.location.href = '/login'
}
